export const locale = {
    lang: 'pt',
    data: {
      'MODALES': {
        'ERROR_DATOS':'Ocorreu um erro A-721',
        'VALIDACION':{
          'ERROR1':'Ainda tem perguntas não traduzidas',
          'WARNING-SIN-TRADUCCION':'Por favor adicione a sua tradução reagente',
          'MODAL-GUARDANDO':'Poupar Reactivo'
        },
        'TITULO': 'Um erro ocorreu',
        'TITULOS': {
          'error': 'Um erro ocorreu',
          'adver': 'Aviso',
          'aviso': 'Aviso prévio',
          'opSuc': 'Ação concluída'
        },
        'ACCIONES': {
          'aceptar' : 'Aceitar',
          'cancelar': 'Cancelar',
          'INFORMATIVO': 'Não mostrar mensagem novamente'
        },
        'EXPEDIENTES':{
          'Resultados': 'Os resultados da pesquisa ainda não estão disponíveis',
          'CARGANDO_COLABORADORES':'Carregando colaboradores que precisam de acompanhamento médico',
        },
        'MENSAJES': {
          'NO_FECH_LAN':'Dados incompletos, selecione a data de lançamento do produto',
          'NO_RESU_ACTI':'No momento os resultados não estão disponíveis, por favor, tente novamente mais tarde',
          'OK':'OK',
          'Something is wrong': 'Algo está mal',
          'password wrong': 'A senha digitada está incorreta',
          'User does not exist': 'O email digitado não está registrado em CULTURAL GO®',
          '150': 'Colaboradores inseridos',
          'Error: user already exist': 'O usuário que está tentando se registrar já existe em CULTURAL GO®',
          'CONEX': {
            'SIN': 'Seu computador perdeu a conexão à Internet \ n \ nPara continuar usando a plataforma, conecte-o à Internet',
            'CON': 'Seu computador recuperou a conexão à Internet \ n \ nAgora você pode continuar usando a plataforma'
          },
          'WIZARD': {
            'CERTIFICAR' : {
              'RESTRICCIONES': {
                'rest1': 'Para acessar esta seção, você precisa escolher os <b> idiomas </b> para a pesquisa',
                'rest2': 'Para acessar esta seção, você precisa concluir todas as etapas anteriores',
                'rest3': 'Para acessar esta seção, é necessário concluir a <b> programação da pesquisa </b>',
                'rest4': 'Para acessar esta seção, é necessário que você <b> envie e-mails </b> para seus colaboradores e que a pesquisa tenha sido lançada',
                'rest5': 'Para acessar esta seção, você precisa configurar os <b> Dados demográficos </b> da pesquisa'
              },
              'IDIOMAS': {
                'NADA': 'Você ainda não selecionou os idiomas principal e adicional',
                'NODEFAULT': 'Você ainda não selecionou o idioma principal',
                'NOADICIONAL': 'Você ainda não selecionou idiomas adicionais',
                'COMPLETAR': 'Você tem certeza de concluir a etapa com a seleção atual de idiomas?',
                '210': 'A etapa foi concluída com êxito',
                'COMPLETADO': 'Você já concluiu esta etapa',
                'RESTRICCION': 'Você não pode executar esta ação depois de concluir esta etapa',
                'INFORMATIVO': 'Nesta seção, você escolhe o idioma principal e os idiomas adicionais nos quais a pesquisa será apresentada ao colaborador.',
                'ARCHIVOCOMFIRM':'Aviso! Trabalhe o arquivo do excel em um único sistema operacional para evitar conflitos de codificação.',
                'BOTONTEXTO':'Consciente',
              },
              'TEMPLATE': {
                // 'NADA': 'Aún no ha realizado la selección de los idiomas principal y adicionales',
                // 'NODEFAULT': 'Aún no ha seleccionado el idioma principal',
                // 'NOADICIONAL': 'Aún no ha seleccionado idiomas adicionales',
                // 'COMPLETAR': '¿Está seguro de completar el paso con la selección actual de idiomas?',
                // '210': 'El paso se completó correctamente',
                // 'COMPLETADO': 'Ya ha completado este paso',
                // 'RESTRICCION': 'No es posible realizar esta acción una vez que ya ha completado este paso',
                'INFORMATIVO': 'Nesta seção você pode fazer alterações no modelo',
                // 'ARCHIVOCOMFIRM':'¡Advertencia! Asegúrate de trabajar el archivo de Excel en un único sistema operativo para evitar conflictos de codificación',
                // 'BOTONTEXTO':'Enterado',

                // 'TITULO_DESBLOQUEAR': '<span>¿Está seguro de reabrir el paso de idiomas, tenga en cuenta que esto <font color="red">reiniciará</font> su producto actual y borrará toda la información que haya agregado a las secciones?</span>',
                // 'BOTON_CONFIRM': 'Sí, reabrir',
                // 'BOTON_CANCEL': 'Cancelar',
                // 'SUCCES': 'El paso ha sido reabierto con éxito',
                // 'BLOQUEADO': 'El paso ya esta abierto',
                // 'CERRAR': 'Cerrar'
              },
              'NPS': {
                'NADA': 'Você não criou nenhum NPS ou marcou a opção sem o NPS',
                'COMPLETAR': 'Tem certeza de que você completou a etapa com seu NPS atual?',
                '219': 'A etapa foi concluída com êxito',
                '220': 'A etapa foi concluída com êxito',
                'COMPLETADO': 'Você já concluiu esta etapa',
                'RESTRICCION': 'Você não pode executar esta ação depois de concluir esta etapa',
                'INFORMATIVO': 'Nesta seção, você pode modificar seu NPS para a pesquisa',
                'FALTANTES_TRADUCCIONES': 'Você ainda não completou o preenchimento das traduções para todas as questões',
                'FALTANTES_SECCIONES_ESPECIALES': 'Você ainda não entrou com a chave da seção especial',
                'FALTANTES_RESPUESTAS': 'Você não pode concluir esta etapa ainda, todas as perguntas de opção múltipla devem ter pelo menos duas opções de resposta',
                'SIN_PREGUNTAS': 'Você precisa adicionar pelo menos uma pergunta para completar a etapa',
                'SIN_GRUPOS': 'Você precisa adicionar pelo menos um grupo de perguntas com uma pergunta dentro para completar a etapa',
                'FALTANTES': 'Você ainda não concluiu o preenchimento do seu NPS'
              },
              'REACTIVOS': {
                'NADA': 'Você não criou nenhum reagente ou marcou a opção sem reagentes',
                'COMPLETAR': 'Tem certeza de que concluiu a etapa com os reagentes inseridos atualmente?',
                '218': 'A etapa foi concluída com êxito',
                'COMPLETADO': 'Você já concluiu esta etapa',
                'RESTRICCION': 'Você não pode executar esta ação depois de concluir esta etapa',
                'INFORMATIVO': 'Nesta seção, você pode adicionar itens à pesquisa',
                'FALTANTES_TRADUCCIONES': 'Você ainda não completou o preenchimento das traduções para todas as questões',
                'FALTANTES_SECCIONES_ESPECIALES': 'Você ainda não entrou com a chave da seção especial',
                'FALTANTES_RESPUESTAS': 'Você não pode concluir esta etapa ainda, todas as perguntas de opção múltipla devem ter pelo menos duas opções de resposta',
                'SIN_PREGUNTAS': 'Você precisa adicionar pelo menos uma pergunta para completar a etapa',
                'SIN_GRUPOS': 'Você precisa adicionar pelo menos um grupo de perguntas com uma pergunta dentro para completar a etapa',
                'FALTANTES': 'Você ainda não completou o preenchimento de seus reagentes'
              },
              'FORALL': {
                'NADA': 'Você ainda não concluiu o preenchimento do 4ALL Practice',
                'COMPLETAR': 'Tem certeza de que você completou a etapa com as práticas 4ALL atualmente introduzidas?',
                '212': 'A etapa foi concluída com êxito',
                'COMPLETADO': 'Você já concluiu esta etapa',
                'RESTRICCION': 'Você não pode executar esta ação depois de concluir esta etapa',
                'INFORMATIVO': 'Esta seção lista as atividades realizadas na empresa, que envolvem a participação de todos os funcionários',
                'NADA_TRA': 'Você ainda não concluiu as traduções do estágio 4ALL',
                'FALTANTES_TRADUCCIONES': 'Você ainda não completou o preenchimento das traduções para todas as questões',
                'FALTANTES_SECCIONES_ESPECIALES': 'Você ainda não entrou com a chave da seção especial',
                'FALTANTES_RESPUESTAS': 'Você não pode concluir esta etapa ainda, todas as perguntas de opção múltipla devem ter pelo menos duas opções de resposta',
                'SIN_PREGUNTAS': 'Você precisa adicionar pelo menos uma pergunta para completar a etapa',
                'SIN_GRUPOS': 'Você precisa adicionar pelo menos um grupo de perguntas com uma pergunta dentro para completar a etapa',
              },
              'CONTROL': {
                'NADA': 'Você não criou uma pergunta de controle ou verificou a opção sem controle',
                'COMPLETAR': 'Tem certeza de que você concluiu a etapa com sua pergunta de controle atual?',
                '221': 'A etapa foi concluída com êxito',
                'COMPLETADO': 'Você já concluiu esta etapa',
                'RESTRICCION': 'Você não pode executar esta ação depois de concluir esta etapa',
                'INFORMATIVO': 'Nesta seção, você pode modificar sua pergunta de controle para a pesquisa',
                'FALTANTES_TRADUCCIONES': 'Você ainda não completou o preenchimento das traduções para todas as questões',
                'FALTANTES_SECCIONES_ESPECIALES': 'Você ainda não entrou com a chave da seção especial',
                'FALTANTES_RESPUESTAS': 'Você não pode concluir esta etapa ainda, todas as perguntas de opção múltipla devem ter pelo menos duas opções de resposta',
                'SIN_PREGUNTAS': 'Você precisa adicionar pelo menos uma pergunta para completar a etapa',
                'SIN_GRUPOS': 'Você precisa adicionar pelo menos um grupo de perguntas com uma pergunta dentro para completar a etapa',
                'FALTANTES': 'Você ainda não concluiu o preenchimento da sua pergunta de controle'
              },
              'DEMOGRAFICOS': {
                'NADA': 'Dados demográficos ainda não selecionados',
                'COMPLETAR': 'Tem certeza de que você concluiu a etapa com as informações demográficas inseridas atualmente?',
                '213': 'A etapa foi concluída com êxito',
                'COMPLETADO': 'Você já concluiu esta etapa',
                'RESTRICCION': 'Você não pode executar esta ação depois de concluir esta etapa',
                'FALTANTES_TRADUCCIONES': 'Você ainda não completou o preenchimento das traduções para todas as questões',
                'FALTANTES_SECCIONES_ESPECIALES': 'Você ainda não entrou com a chave da seção especial',
                'FALTANTES_RESPUESTAS': 'Você não pode concluir esta etapa ainda, todas as perguntas de opção múltipla devem ter pelo menos duas opções de resposta',
                'SIN_PREGUNTAS': 'Você precisa adicionar pelo menos uma pergunta para completar a etapa',
                'SIN_GRUPOS': 'Você precisa adicionar pelo menos um grupo de perguntas com uma pergunta dentro para completar a etapa',
                'INFORMATIVO': 'Esta seção estabelece as opções demográficas que serão disponibilizadas ao colaborador na pesquisa.'
              },
              'ABIERTAS': {
                'NADA': 'Você não criou perguntas abertas ou marcou a opção sem perguntas abertas',
                'COMPLETAR': 'Tem certeza de que você concluiu a etapa com as perguntas abertas inseridas atualmente?',
                '220': 'A etapa foi concluída com êxito',
                '219': 'A etapa foi concluída com êxito',
                'COMPLETADO': 'Você já concluiu esta etapa',
                'RESTRICCION': 'Você não pode executar esta ação depois de concluir esta etapa',
                'INFORMATIVO': 'Nesta seção, você pode adicionar perguntas abertas à pesquisa',
                'FALTANTES_TRADUCCIONES': 'Você ainda não completou o preenchimento das traduções para todas as questões',
                'FALTANTES_SECCIONES_ESPECIALES': 'Você ainda não entrou com a chave da seção especial',
                'FALTANTES_RESPUESTAS': 'Você não pode concluir esta etapa ainda, todas as perguntas de opção múltipla devem ter pelo menos duas opções de resposta',
                'SIN_PREGUNTAS': 'Você precisa adicionar pelo menos uma pergunta para completar a etapa',
                'SIN_GRUPOS': 'Você precisa adicionar pelo menos um grupo de perguntas com uma pergunta dentro para completar a etapa',
                'FALTANTES': 'Você ainda não concluiu o preenchimento das perguntas abertas'
              },
              'ADICIONALES': {
                'NADA': 'Você não criou nenhuma pergunta adicional ou marcou a opção sem perguntas adicionais',
                'COMPLETAR': 'Tem certeza de que você completou a etapa com perguntas adicionais inseridas no momento?',
                '214': 'A etapa foi concluída com êxito',
                'COMPLETADO': 'Você já concluiu esta etapa',
                'RESTRICCION': 'Você não pode executar esta ação depois de concluir esta etapa',
                'FALTANTES_TRADUCCIONES': 'Você ainda não completou o preenchimento das traduções para todas as questões',
                'FALTANTES_SECCIONES_ESPECIALES': 'Você ainda não entrou com a chave da seção especial',
                'FALTANTES_RESPUESTAS': 'Você não pode concluir esta etapa ainda, todas as perguntas de opção múltipla devem ter pelo menos duas opções de resposta',
                'SIN_PREGUNTAS': 'Você precisa adicionar pelo menos uma pergunta para completar a etapa',
                'SIN_GRUPOS': 'Você precisa adicionar pelo menos um grupo de perguntas com uma pergunta dentro para completar a etapa',
                'INFORMATIVO': 'Nesta seção, você pode adicionar perguntas personalizadas à pesquisa'
              },
              'COLABORADORES': {
                'NADA': 'Você ainda não enviou as informações de seus colaboradores para CULTURAL GO®',
                'NADA_OPCION': 'Você ainda não configurou se o convite será enviado por e-mail',
                'COMPLETAR': 'Tem certeza de que concluiu a etapa com a lista de contribuidores atualmente carregada?',
                '211': 'A etapa foi concluída com êxito',
                '200': 'A etapa foi concluída com êxito',
                'COMPLETADO': 'Você já concluiu esta etapa',
                'RESTRICCION': 'Você não pode executar esta ação depois de concluir esta etapa',
                'INFORMATIVO': 'Esta seção carrega a lista de colaboradores para quem o convite da pesquisa será enviado por email',
                'ACTUALIZAR': 'Os colaboradores foram adicionados com sucesso à pesquisa'
              },
              'PROGRAMACION': {
                'NADA': 'Você ainda não agendou datas',
                'NADA1': 'Nenhuma data de lançamento agendada ainda',
                'NADA2': 'Você ainda não definiu uma data de lembrete',
                'COMPLETAR': 'Tem certeza de que você completou a etapa com as datas programadas?',
                '215': 'A etapa foi concluída com êxito',
                '217': 'A etapa foi concluída com êxito', //CERTIFICAR2.0
                'COMPLETADO': 'Você já concluiu esta etapa',
                'FECHALANZAMIENTO': 'Você ainda não inseriu sua data de lançamento',
                'RESTRICCION': 'Você não pode executar esta ação depois de concluir esta etapa',
                'INFORMATIVO': 'Esta seção estabelece as datas para iniciar e enviar lembretes para a realização da pesquisa.',
                'INFORMATIVO2': 'Esta seção estabelece as datas de envio para as pesquisas.',
                'GUARDA-OK':'A data foi salva com sucesso',
                'OK':'OK',
                'NOT_MESS_COM':'Esta função não é permitida',
                'DETEC_CAMBIOS_SECCIONES':'Foram detectadas mudanças na configuração das seções, gerando novamente o levantamento.',


              },
              'ENVIO': {
                'NADA': 'Você ainda não enviou o convite da pesquisa para seus colaboradores',
                'COMPLETAR': 'Tem certeza de que você completou a etapa?',
                '216': 'A etapa foi concluída com êxito',
                'COMPLETADO': 'Você já concluiu esta etapa',
                'RESTRICCION': 'Você não pode executar esta ação depois de concluir esta etapa',
                'INFORMATIVO': 'Esta seção executa o envio do convite para a realização da pesquisa aos colaboradores'
              },
              'CONFIRMACION': {
                // 'NADA': 'Aún no ha realizado el envío de la invitación a la encuesta a sus colaboradores',
                // 'NADA_OPCION': 'Aún no ha configurado si el envío de la invitación se hará por correo electrónico',
                // 'COMPLETAR': '¿Está seguro de completar el paso?',
                // '216': 'El paso se completó correctamente',
                // 'COMPLETADO': 'Ya ha completado este paso',
                // 'RESTRICCION': 'No es posible realizar esta acción una vez que ya ha completado este paso',
                 'INFORMATIVO': 'Nesta seção, você pode ativar ou desativar a pesquisa',
                // 'TITULO_DESBLOQUEAR': '¿Está seguro de reabrir el paso de envío de correos?',
                // 'BOTON_CONFIRM': 'Sí, reabrir',
                // 'BOTON_CANCEL': 'Cancelar',
                // 'SUCCES': 'El paso ha sido reabierto con éxito',
                // 'BLOQUEADO': 'El paso ya esta abierto',
                // 'CERRAR': 'Cerrar'
              },
              'CIERRE': {
                'NADA': 'A pesquisa ainda não está concluída',
                'COMPLETAR': 'Tem certeza de que você completou a etapa?',
                '217': 'A etapa foi concluída com êxito',
                'COMPLETADO': 'Você já concluiu esta etapa',
                'RESTRICCION': 'Você não pode executar esta ação depois de concluir esta etapa',
                'INFORMATIVO': 'Nesta seção, você pode verificar o progresso atual da pesquisa e realizar o fechamento antecipado da pesquisa.',
                'INFORMATIVO2': 'Nesta seção, você pode verificar o progresso atual de cada uma das pesquisas.'
              }
            },
            'NOM35': {
              'CENTROS': {
                'AUTOLOGIN': {
                  'TITULO': 'Aviso',
                  'INFO': 'Aviso \ n \ nSua sessão será encerrada e você prosseguirá com o login no centro de trabalho selecionado. \ N \ nConfirmar login com o centro de trabalho?',
                  'INFOODS': 'Aviso \ n \ nSua sessão será encerrada e você prosseguirá com a empresa selecionada. \ N \ nConfirmar login com a empresa?'
                }
              }
            },
            'FOCUS':{
              'MODAL-AUNAUTORIZACION':'Ainda não tem autorização ',
              'BTN-ENTERADO':'CONHECIDO',
              'MODAL-AUTORIZACION':'Sua pesquisa foi enviada para validar',


            },
          }
        },
        'ERRORES': {
          'Ocurrió un error desconocido': 'Seu computador ou dispositivo está apresentando uma falha de conexão com a plataforma, por favor, tente acessar novamente mais tarde',
          '102': 'O email digitado não está registrado em CULTURAL GO®',
          '103': 'A senha digitada está incorreta',
          '101': 'O e-mail já está registrado, digite outro',
          'verifyToken_3': '<span>A plataforma sofreu uma atualização recentemente, por este motivo e para evitar perda de informação, a sua sessão será encerrada<br><br>Para garantir o bom funcionamento da plataforma, <font color="red">seu navegador será atualizado automaticamente</font></span>',
          'tokenActLogin': '<span>Recentemente a plataforma teve uma atualização, por este motivo e para garantir o correto funcionamento da plataforma, <font color="red">seu navegador será atualizado automaticamente</font>, posteriormente você poderá acessar a plataforma normalmente</span>',
          'Demo keys out of stock': 'Usuários de demonstração de pesquisa estão exaustos',
          'Keys Out Of Stock': 'Usuários de demonstração de pesquisa estão exaustos',
          'Error: Please Recreate Survey':'Foram detectadas alterações nas perguntas.\n\n Para continuar, é favor recriar o inquérito.',
          'IT Manager Not Found':'O e-mail não foi enviado para o gerente de TI.\n\ndigite o e-mail e envie manualmente.',
          'NO_PROCC_PROD_ASO':'O produto associado não foi processado até o momento',
          'ERR_PROCC_PROD_ACT': 'Erro na actualização de utilizadores em SQL',
          '300': 'O e-mail introduzido não tem permissões de acesso',
        },
        'ELIMINAR':{
          'MENSAJETEXTO1': '<span>Para confirmar a alienação da empresa ',
          'MENSAJETEXTO2': ', insira o nome da empresa na caixa de texto</span>',
          'SALIR': 'Saída',
          'VALIDAR': 'Confirme a empresa',
          'ERRORNOMBREEMPRESA': 'O nome da empresa inserido não corresponde ao nome da empresa a ser excluída',
          'MENSAJE': 'Você tem certeza?\n\nVocê está prestes a excluir a empresa ',
          'CANCELAR': 'Cancelar',
          'CONFIRMAR': 'Sim remova',
          'SUCCES': 'Empresa eliminada',
          'CERRAR': 'Perto'
        }
      }
    }
};
